/**
 * Simple localStorage wrapper
 * @param {String} namespace
 */
export default function localStore(namespace) {
  return {
    fetch: key => fetchItem(namespace, key),
    set: (key, value) => setItem(namespace, key, value)
  };
}

function fetchItem(namespace, key) {
  const value = window.localStorage.getItem(`${namespace}${key}`);
  return value && JSON.parse(value);
}

function setItem(namespace, key, value) {
  window.localStorage.setItem(`${namespace}${key}`, JSON.stringify(value));
}
